module.exports = __webpack_public_path__ + "static/media/title.5c5a4239.png";